export default __webpack_public_path__ + "static/media/icon_ios.a4cd1b36.jpg";